import React from 'react';
import Link from 'gatsby-link';
import MediaQueries from 'react-responsive';

import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Position from '@marvelapp/marvel-ui/position';
import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Align from '@marvelapp/marvel-ui/align';
import Button from '@marvelapp/marvel-ui/button';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';

import ClickAround from 'marketing-website/components/icons/ClickAround';

export default function Images() {
  return (
    <Spacing size="l" sizeM="xl" type="padding" position="topBottom">
      <MaxWidth value={720}>
        <Grid columns={2} size="l" alignItems="center" justifyContent="center">
          <GridItem columnSpan={2} columnSpanM={1}>
            <Position type="relative">
              <iframe
                src="https://marvelapp.com/aj3a74?emb=1"
                width="270"
                height="420"
                allowTransparency="true"
                frameBorder="0"
              />
              <MediaQueries minWidth={770}>
                <Position type="absolute" right={-100} top={-100}>
                  <ClickAround />
                </Position>
              </MediaQueries>
            </Position>
          </GridItem>
          <GridItem columnSpan={2} columnSpanM={1}>
            <Align type="center" typeM="left">
              <Spacing size="s" type="padding" position="topBottom">
                <Heading tag="h2" weight="semibold" size="xl">
                  Create and view prototypes on the web or on your phone
                </Heading>
              </Spacing>
              <Paragraph size="l" color="slate">
                Even if you don't have a watch, you can still create and view
                prototypes using our web app. Click around on the example on the
                left then sign up to get started.
              </Paragraph>
              <Spacing size="m" type="padding" position="topBottom">
                <Link to="/signup">
                  <Button shape="rounded" size="large">
                    Get started
                  </Button>
                </Link>
              </Spacing>
            </Align>
          </GridItem>
        </Grid>
      </MaxWidth>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/pages/apple-watch-prototyping/embed.js